import type {
  PrivacyLocale,
  PrivacyTranslations,
} from "../types";



export const privacyTranslations: Record<
  PrivacyLocale,
  PrivacyTranslations
> = {


  it: {

    bannerMessage:
      "Utilizziamo cookie e tecnologie simili per migliorare la tua esperienza sul sito.",


    acceptAll:
      "Accetta tutti",


    rejectAll:
      "Rifiuta",


    customize:
      "Personalizza",


    preferencesTitle:
      "Preferenze privacy",


    necessaryCookies:
      "Cookie necessari",


    analytics:
      "Analytics",


    marketing:
      "Marketing",


    preferences:
      "Preferenze",


    savePreferences:
      "Salva preferenze",


    close:
      "Chiudi",


    manageCookies:
      "Gestisci preferenze cookie",


    privacyPolicy:
      "Privacy Policy",


    cookiePolicy:
      "Cookie Policy",

  },



  en: {

    bannerMessage:
      "We use cookies and similar technologies to improve your experience on the site.",


    acceptAll:
      "Accept all",


    rejectAll:
      "Reject",


    customize:
      "Customize",


    preferencesTitle:
      "Privacy preferences",


    necessaryCookies:
      "Necessary cookies",


    analytics:
      "Analytics",


    marketing:
      "Marketing",


    preferences:
      "Preferences",


    savePreferences:
      "Save preferences",


    close:
      "Close",


    manageCookies:
      "Manage cookie preferences",


    privacyPolicy:
      "Privacy Policy",


    cookiePolicy:
      "Cookie Policy",

  }


};